import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavBar from '../dashboard/components/TopNavBar';
import FinanceBillingTab from '../admin-dashboard/components/FinanceBillingTab';
import NavigationPreventer from '../../components/NavigationPreventer';
import { useAuth } from '../../state/auth/useAuth';

const FinancePage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('finance');

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    switch (tabId) {
      case 'dashboard':
        navigate('/dashboard');
        break;
      case 'master-data':
        navigate('/admin/dashboard');
        break;
      case 'patients':
        navigate('/users');
        break;
      case 'inventory':
        navigate('/inventory');
        break;
      case 'finance':
        // Stay on this page
        break;
      case 'reports':
        navigate('/accounting');
        break;
      case 'settings':
        navigate('/hospital-settings');
        break;
      case 'profile':
        console.log('Profile navigation - route not yet configured');
        break;
      default:
        break;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50" style={{ fontFamily: 'Poppins' }}>
      <NavigationPreventer />
      <TopNavBar
        user={user}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      <main className="pt-20 px-4 lg:px-6">
        <div className="space-y-4">
          {/* Header */}
          <div className="bg-white rounded-xl border-2 border-gray-200 shadow-sm p-5">
            <h1 className="text-2xl font-bold text-gray-900 mb-1">
              Finance &amp; Billing
            </h1>
            <p className="text-sm text-gray-600">
              Revenue collected, doctor-wise breakdown, and outstanding payment tracking
            </p>
          </div>

          {/* Finance Tab Content */}
          <FinanceBillingTab />
        </div>
      </main>
    </div>
  );
};

export default FinancePage;
